// extracted by mini-css-extract-plugin
module.exports = {"StockPeersPage":"peers_StockPeersPage__BBlnN"};